const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;
const TIME_DISPLAY_PADDING = 2;
const ZERO_PADDING_CHAR = "0";

const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / SECONDS_PER_HOUR)
    .toString()
    .padStart(TIME_DISPLAY_PADDING, ZERO_PADDING_CHAR);
  const mins = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)
    .toString()
    .padStart(TIME_DISPLAY_PADDING, ZERO_PADDING_CHAR);
  const secs = (seconds % SECONDS_PER_MINUTE)
    .toString()
    .padStart(TIME_DISPLAY_PADDING, ZERO_PADDING_CHAR);
  return `${hours}:${mins}:${secs}`;
};

export default formatDuration;
